module.exports = __webpack_public_path__ + "img/wkt_content4.fb0b00dd.png";